import { X } from "lucide-react";
import { cn, Tooltip } from "saphir";

import { useLocalStorage } from "@lib/hooks";
import { i18n } from "@lib/i18n";
import trackEvent from "@lib/trackers";
import { useFlag } from "@unleash/proxy-client-react";

import QRCodeSidePro from "./qr-sidepro.webp";
import SideProLogo from "./sidepro.png";

export function useSideProVisibility() {
    const isSideProEnabled = useFlag("mobile_app_promo_sidebar");
    const [sideProVisible, setSideProVisible] = useLocalStorage("sideProVisible", "true");

    return {
        isSideProVisible: isSideProEnabled && sideProVisible !== "false",
        hideSidePro: () => {
            setSideProVisible("false");
            void trackEvent({
                name: "announcement - side pro dismissed",
                params: {
                    organisationId: localStorage.getItem("side_team_activeOrganisationId") ?? "",
                    page: window.location.pathname.split("/").filter(Boolean).at(-1) ?? "",
                },
            });
        },
    };
}

export function SidePro({
    origin = "menu",
    onClose,
}: {
    origin?: "signin" | "menu";
    onClose: () => void;
}) {
    const text = (
        <p
            className={cn(
                "typography-body-s-semibold text-gray-700",
                origin === "menu" && "self-stretch text-center",
            )}
        >
            {i18n.side_pro_banner_text()}
        </p>
    );

    return (
        <div
            className={cn(
                "bg-gray-20 animate-in relative flex items-center rounded border-2 border-[#bcf851] py-4 pl-3 duration-500",
                origin === "menu"
                    ? "fade-in slide-in-from-left flex-col gap-1 pr-3"
                    : "fade-in mb-4 flex-row gap-4 pr-10",
            )}
        >
            <Tooltip content={i18n.dont_show_again()} delayDuration={0}>
                <button
                    type='button'
                    aria-label={i18n.dont_show_again()}
                    className='focus:focus-ring absolute top-2 right-2 flex cursor-pointer rounded p-1 text-gray-700'
                    onClick={onClose}
                >
                    <X className='size-5' />
                </button>
            </Tooltip>
            {origin === "menu" ? (
                <>
                    <img className='w-20' src={SideProLogo} />
                    {text}
                    <img
                        className='mt-1 size-18 min-w-0'
                        src={QRCodeSidePro}
                        alt={i18n.side_pro_banner_qr_code_alt()}
                    />
                </>
            ) : (
                <>
                    <img
                        className='size-20 min-w-0 shrink-0'
                        src={QRCodeSidePro}
                        alt={i18n.side_pro_banner_qr_code_alt()}
                    />
                    <div>
                        <img className='w-24' src={SideProLogo} />
                        {text}
                    </div>
                </>
            )}
        </div>
    );
}
